import { jsxs, jsx } from 'react/jsx-runtime';
import { ListboxInput, ListboxButton, ListboxPopover, ListboxList } from '@reach/listbox';
import { Button } from '../Button/Button.js';
import { DropdownMenuItem } from './DropdownMenuItem.js';

const DropdownMenu = ({
  label,
  children,
  name,
  onChange,
  value = ''
}) => jsxs(ListboxInput, {
  className: "relative",
  name: name,
  onChange: onChange,
  value: value,
  children: [jsx(ListboxButton, {
    as: Button,
    variant: "text",
    children: label
  }), jsx(ListboxPopover, {
    portal: false,
    children: jsx(ListboxList, {
      className: "\n            absolute right-0 top-xl z-10 flex min-w-[402px] flex-col divide-x-0 divide-y divide-solid\n            divide-gray rounded bg-white drop-shadow transition-all duration-hover ease-linear\n          ",
      children: children
    })
  })]
});
DropdownMenu.Item = DropdownMenuItem;

export { DropdownMenu };
